<template>
  <div class="container">
    <baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler" :scroll-wheel-zoom="true">
      <!--缩放-->
      <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
      <!--定位-->
      <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
      <!--点-->
      <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">
        <!--提示信息-->
        <!-- <bm-info-window :show="map.show">Hello~</bm-info-window> -->
      </bm-marker>
    </baidu-map>

    <div class="map-nav">
      <h3 @click="setCenter()">{{hospInfo.name}}</h3>
      <p>{{hospInfo.address}}</p>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .container {
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .map {
    flex: 1;
    width: 100%;
  }

  .map-nav {
    bottom: 0;
    width: 100%;
    background: #ffffff;
    padding: 12px;

    h3 {
      font-size: 20px;
      line-height: 32px;
      margin-bottom: 8px;
    }
  }
</style>

<script>
  import Vue from "vue";
  import BaiduMap from "vue-baidu-map";
  import {
    mapState,
    mapMutations,
    mapActions
  } from "vuex";
  Vue.use(BaiduMap, {
    ak: "KeF9nGlO6RAWP4Bx73GC604p86HrAuii"
  });
  export default {
    data() {
      return {
        map: {
          ak: "KeF9nGlO6RAWP4Bx73GC604p86HrAuii",
          center: {
            // lng: 121.457437, //经度
            // lat: 31.236321 //纬度
          },
          zoom: 16,
          show: true,
          dragging: false, //不允许拖动
        }
      };
    },
    computed: {
      ...mapState({
        hospInfo: state => state.hospital.hospInfo
      })
    },
    created() {
      this.map.center = {
        lng: this.hospInfo.mapX, //经度
        lat: this.hospInfo.mapY //纬度
      }
    },
    methods: {
      handler({
        BMap,
        map
      }) {
        let me = this;
        //console.log(BMap, map);
        // 鼠标缩放
        map.enableScrollWheelZoom(true);
        // 点击事件获取经纬度
        map.addEventListener("click", function (e) {
          //console.log(e.point.lng, e.point.lat);
        });
      },
      setCenter() {
        this.map.center = {
          lng: 121.457437, //经度
          lat: 31.236321 //纬度
        };
        console.log("2");
      }
    }
  };
</script>